import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import Chevron from '~/components/chevron';
import PermissionChecker from '~/components/permission_checker';
import { useAppSidebar } from '../provider';
import { MenuStates } from '../provider/enums';
const MenuItem = (props) => {
    const { actionMenu: ActionMenu, component: Component, permissions, route, title, icon, } = props;
    const { activeRoute, expandedItem, toggleExpandedItem } = useAppSidebar();
    const isExpanded = expandedItem === route;
    const itemClass = classnames('nav-item', {
        active: activeRoute.includes(route),
    });
    const navigateTo = (route === MenuStates.ProjectsWorkspace) ? {} : route;
    return (React.createElement(PermissionChecker, { requiredAnyPermissions: permissions },
        React.createElement("div", { className: itemClass },
            React.createElement("div", { className: "nav-item-container", onClick: () => toggleExpandedItem(route) },
                React.createElement(Link, { title: `Navigate to ${title}`, to: navigateTo },
                    icon,
                    React.createElement("p", { className: 'menu-title' },
                        title,
                        "\u00A0"),
                    ActionMenu && (React.createElement(ActionMenu, { render: isExpanded })),
                    Component && (React.createElement("div", { className: 'menu-chevron' },
                        React.createElement(Chevron, { title: 'Expand', isExpanded: isExpanded }))))),
            Component && (React.createElement(Component, { render: isExpanded })))));
};
export default MenuItem;
